import { NgModule } from '@angular/core';
import { DeliveryZonesFormComponent } from './delivery-zones-form/delivery-zones-form.component';
import { DeliveryZonesListComponent } from './delivery-zones-list/delivery-zones-list.component';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { DxModule } from '../../../shared/dx.module';
import { MaterialModule } from '../../../shared/material.module';
import { PendingChangesGuard } from 'src/app/guards';

export const distributionChannelsRoutes: Route[] = [
  {
    path: '',
    component: DeliveryZonesListComponent
  },
  {
    path: 'new',
    component: DeliveryZonesFormComponent,
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: ':id',
    component: DeliveryZonesFormComponent,
    canDeactivate: [PendingChangesGuard]
  }
];

@NgModule({
  declarations: [DeliveryZonesFormComponent, DeliveryZonesListComponent],
  imports: [
    SharedModule,
    MaterialModule,
    DxModule,
    RouterModule.forChild(distributionChannelsRoutes)
  ]
})
export class DeliveryZonesModule { }
